export default "__VITE_ASSET__vCqBk3Eo__"